<template id="banner-top">
    <div class="col-12 col-md-7 col-lg-6">
        <h2 class="banner-top__white-title">
            Funcionalidades pensadas en tus necesidades
        </h2>
        <p class="banner-top__white-text">
            Descubre las funcionalidades que te ayudarán a presentar propuestas más competitivas, por medio de los datos que centralizamos para ti.
        </p>
        <cta-button
            link="/registrarse"
            class="shadow-button"
            level="success"
            :text="$t($root.lenguaje_pais+'.registro.texto_general', { dias: $root.currentTrialDays })"
            :hiddentext="$t($root.lenguaje_pais+'.registro.texto_hidden', { dias: $root.currentTrialDays })"
        ></cta-button>
    </div>
</template>

<script>
export default {
    name: 'BannerTopFuncionalidades',
    data: () => ({
    })
}
</script>

<style lang="scss" scoped>
</style>